/*jshint esversion: 6 */
export function renderBackground(headerBox, contentBox) {
    var headerDocument = document.getElementById(headerBox);
    var contentDocument = document.getElementById(contentBox);
    document.getElementById(contentBox).style.minHeight = '0px';
    window.setTimeout(function() {
        var windowHeight = window.innerHeight;
        var contentHeight = headerDocument.offsetHeight+contentDocument.offsetHeight;
        if (contentHeight < windowHeight) {
            var substraction = windowHeight - headerDocument.offsetHeight;
            contentDocument.style.minHeight = `${substraction}px`;
        }
    }, 100);
}

export function defineBrowserType(vueApp) {
    switch(true) {
        case (window.innerWidth < 1100): 
            vueApp.browserType = 'mobile';
        break;
        default:
            vueApp.browserType = 'desktop';
        break;
    }
}

export function calcBytes(value) {
    
    const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
   
    function niceBytes(x){

        let l = 0, n = parseInt(x, 10) || 0;

        while(n >= 1024 && ++l){
            n = n/1024;
        }
        
        return(n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    }

    return niceBytes(value);
}

export function calcInBytes(value) {
    return value * 1024 * 1024;
}

export function isJson(str) {
    try {
        JSON.parse(str);
    } catch {
        return false;
    }
    return true;
}

export function setLeadingZero(getNumber) {
    if (getNumber < 10) {
        return `00${getNumber}`;
    } else if (getNumber < 99) {
        return `0${getNumber}`;
    } else {
        return getNumber;
    }
}
